import {
  Archive,
  ArrowBack,
  CardGiftcard,
  GifBoxTwoTone,
  Home,
  MoreVert,
  ShareTwoTone,
  Star,
} from "@mui/icons-material";
import React from "react";
import { Link } from "react-router-dom";
// import Sidebar from "../../../components/sidebar/Sidebar";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import "./moduleview.scss";
import ReactPlayer from "react-player/lazy";
import HomeStudentLayout from "../HomeLayout/HomeLayout";
import AnnounceLayout from "../AnnounceLayout/AnnounceLayout";

import Overview from "./Overview/Overview";
import Accordion from "../../../components/Accordion/Accordion";
import course_data_content from "../../../data/course_content_data.json";
import CircularProgress from "@mui/material/CircularProgress";
import { CircularProgressWithLabel } from "../../../components/CircularProgressWithLabel/CircularProgressWithLabel";
import Action from "../../../components/Action/Action";
import QandA from "./Q&A/Q&A";

function ModuleView(props) {
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const menuChange = (e) => {
    setIndex(e);
    window.scrollTo(0, 0);
  };

  const viewSection = () => {};

  return (
    <div
      className={
        theme === "light" ? "module_view l_b d_t" : "module_view d_b l_t"
      }
    >
      {/* <Sidebar menu="course" /> */}
      <main className="content_container">
      <section className="top_section">
          <ul className={theme === "light" ? "l_w_b" : "l_t"}>
            <li>
              {" "}
              <Link to={"/"}>
                <Home /> Home
              </Link>
            </li>
            <li>
              <Link to={"/courses"}>Courses</Link>
            </li>
            <li>
              <span>Clinical Laboratory</span>
            </li>
          </ul>
        </section>
        <div className="body_container">
          <div className={"player_section"}>
            <a className={theme === "light" ? "l_r_b d_t": "d_r_b l_t"}>Ultimate AWS Certified Developer Associate 2022 - NEW!</a>
            <div
              className={
                theme === "light" ? "player l_r_b d_t" : "player d_r_b l_t"
              }
            >
              <ReactPlayer
                width={"100%"}
                url="https://www.youtube.com/watch?v=ysz5S6PUM-U"
              />
            </div>
            <div
              className={
                theme === "light"
                  ? "tab_section l_r_b d_t"
                  : "tab_section d_r_b l_t"
              }
            >
              <div className="tab_row">
                <button
                  className={index == -1 ? "mobile active" : "mobile"}
                  onClick={() => menuChange(-1)}
                >
                  Course Content
                </button>
                <button
                  className={index == 0 ? "active" : ""}
                  onClick={() => menuChange(0)}
                >
                  Overview
                </button>
                <button
                  className={index == 1 ? "active" : ""}
                  onClick={() => menuChange(1)}
                >
                  Q&A
                </button>
                <button
                  className={index == 2 ? "active" : ""}
                  onClick={() => menuChange(2)}
                >
                  Notes
                </button>
                <button
                  className={index == 3 ? "active" : ""}
                  onClick={() => menuChange(3)}
                >
                  Announcement
                </button>
                <button
                  className={index == 4 ? "active" : ""}
                  onClick={() => menuChange(4)}
                >
                  Reviews
                </button>
                <button
                  className={index == 5 ? "active" : ""}
                  onClick={() => menuChange(5)}
                >
                  Resources
                </button>
              </div>
              <hr />
              <div className="">
                {index == -1 && (
                  <div>
                    {course_data_content.map((item, index) => (
                      <Accordion
                        key={index}
                        item={item}
                        title={item.title}
                        content={item.section}
                        onClick={viewSection}
                      />
                    ))}
                  </div>
                )}
                {index == 0 && <Overview />}
                {index == 1 && <QandA />}
                {/* {index == 2 && <QandA />} */}
              </div>
            </div>
          </div>
          <div
            className={
              theme === "light"
                ? "list_section l_r_b d_t"
                : "list_section d_r_b l_t"
            }
          >
            <div className="header_monitor">
              <Action
                icon={
                  <CircularProgressWithLabel
                    color={"inherit"}
                    size={45}
                    value={90}
                  />
                }
                border={false}
                style={{ width: 160 }}
                content={
                  <div className="column_cert">
                    <b>414 of 458 complete</b>
                    <p>Finish course to get certificate</p>
                  </div>
                }
              />
              <button className="more">
                <ShareTwoTone />
                Share
              </button>

              <Action
                icon={<MoreVert />}
                style={{ width: 140 }}
                border={true}
                content={
                  <div className="column_data">
                    <li>
                      <Star /> Favourite
                    </li>
                    <li>
                      <Archive /> Archive
                    </li>
                    <li>
                      <CardGiftcard /> Gift Course
                    </li>
                  </div>
                }
              />
            </div>
            <div className="lecture_container">
              {course_data_content.map((item, index) => (
                <Accordion
                  key={index}
                  item={item}
                  title={item.title}
                  content={item.section}
                  onClick={viewSection}
                />
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ModuleView;
